import { isEmpty } from "./common";

// 필수 입력 컬럼 목록
const getRequiredColumns = (columns) => {
	const reqCols = [];
	if(Array.isArray(columns)) {
		columns.forEach(col => {
			reqCols.push(...getRequiredColumns(col));
		})
	} else if((typeof columns).toLowerCase() === "object") {
		if(columns.hasOwnProperty("col")) {
			if(columns.require) {
				reqCols.push(columns);
			}
		} else {
			const keys = Object.keys(columns);
			for(const key of keys) {
				reqCols.push(...getRequiredColumns(columns[key]));
			}
		}
	}

	return reqCols;
}

// 필수 체크 통과 못한 column 목록
const getRequiredInvalidCols = (columns, data) => {
	const requireColumns = getRequiredColumns(columns);
	const invalidCols = [];
	for(const col of requireColumns) {
		if(!col.col.includes(".")) {
			if(isEmpty(data[col.col])) {
				invalidCols.push(col);
			}
		} else {

			let nmArr = col.col.split(".");
			let tmpData = data;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];
				tmpData = tmpData?.[key];
			}
			if(isEmpty(tmpData)) {
				invalidCols.push(col);
			}

		}
	}
	return invalidCols;
}

/*
// 필수 체크 및 Alert. 최초 1건 통과 못하면 바로 alert.
export const checkRequiredAndAlert = (columns, data) => {
	const requireColumns = getRequiredColumns(columns);
	for(const col of requireColumns) {
		if(isEmpty(data[col.col])) {
			alert("필수항목이 누락되었습니다. [" + col.header + "]");
			document.querySelector("[name='" + col.col + "']").focus();
			return false;
		}
	}
	return true;
}
	*/


// 필수 체크 및 invalid 설정. Object용
const checkRequiredAndInvalidForObject = (columns, data, preSelector = "") => {
	let result = true;
	const invalidCols = getRequiredInvalidCols(columns, data);
	if(invalidCols.length > 0) {
		result = false;
		for(const invalidCol of invalidCols) {
			const objArr = document.querySelectorAll(preSelector + " [name='" + invalidCol.col + "']");
			for(const obj of objArr) {
				setInvalid(obj);
			}
		}
	}
	if(!result) alert("필수항목이 누락되었습니다.");
	return result;
}
// 데이터 변경 시 invalid 제거. Object용.
const checkAndRemoveInvalidForObject = (data, preSelector = "") => {
	const invalidObjList = document.querySelectorAll(preSelector + " .invalid");
	for(const obj of invalidObjList) {
		
		if(obj.name.includes(".")) {
			const objName = obj.name;
			let nmArr = objName.split(".");
			let tmpObj = data;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];
				if(tmpObj) {
					tmpObj = tmpObj[key];
				}
			}
			if(tmpObj) {
				removeInvalid(obj);
			}

		} else {
			if(data[obj.name]) {
				removeInvalid(obj);
			}
		}

		// if(data[obj.name]) {
		// 	removeInvalid(obj);
		// }
	}
}

// 필수 체크 및 invalid 설정. 리스트용(ReactDataTableModifiable)
const checkRequiredAndInvalidForList = (columns, dataList, preSelector = "") => {
	let result = true;
	dataList.forEach((data, index) => {
		const invalidCols = getRequiredInvalidCols(columns, data);
		if(invalidCols.length > 0) {
			result = false;
			for(const invalidCol of invalidCols) {
				const obj = document.querySelector(preSelector + " tbody tr:nth-of-type(" + (index+1) + ") [name='" + invalidCol.col + "']");
				setInvalid(obj);
			}
		}
	})
	if(!result) alert("필수항목이 누락되었습니다.");
	return result;
}
// 데이터 변경 시 invalid 제거. 리스트용(ReactDataTableModifiable)
const checkAndRemoveInvalidForList = (dataList, preSelector = "") => {
	document.querySelectorAll(preSelector + " tbody tr").forEach(function(tr, index) {
		const invalidObjList = tr.querySelectorAll(".invalid");
		for(const obj of invalidObjList) {
			if(dataList?.[index]?.[obj.name]) {
				removeInvalid(obj);
			}

		}
	});
}

//////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
// 여기부터 export 용
//////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
// obj에 invalid 클래스 설정.
export const setInvalid = (obj) => {
	if(!obj) return;
	let className = obj.className.replace(" invalid ", "");	// 넣기전에 혹시 앞서 남아있을지 모르는 invalid를 제거하고
	className += " invalid ";
	obj.className = className;
}

// obj에서 invalid 클래스 제거.
export const removeInvalid = (obj) => {
	if(!obj) return;
	obj.className = obj.className.replace(" invalid ", "");
}

// 컬럼을 사용하지 않는 경우 function을 사용하기 위함.
export const makeRequireColumns = (colArr) => {
	const result = [];
	for(const col of colArr) {
		if((typeof col).toLowerCase() === "object") {
			result.push({...col, require: true});
		} else {
			result.push({col: col, require: true});
		}
	}
	return result;
}

// 필수 체크 및 invalid 설정. data 형식에 따라 List or Object용으로 처리
export const checkRequiredAndInvalid = (columns, data, preSelector = "") => {
	if(Array.isArray(data)) {
		return checkRequiredAndInvalidForList(columns, data, preSelector);
	} else {
		return checkRequiredAndInvalidForObject(columns, data, preSelector);
	}
}
// 데이터 변경 시 invalid 제거. data 형식에 따라 List or Object용으로 처리
export const checkAndRemoveInvalid = (data, preSelector = "") => {
	if(Array.isArray(data)) {
		checkAndRemoveInvalidForList(data, preSelector);
	} else {
		checkAndRemoveInvalidForObject(data, preSelector);
	}
}
